import { IMergeEventLabels } from '../../../actions/bookingCalendar/calendar/eventLabels'
import { IBookingCalendarStore } from '../index'

export default function(
  state: IBookingCalendarStore,
  action: IMergeEventLabels,
): IBookingCalendarStore {
  return {
    ...state,
    eventLabels: {
      ...state.eventLabels,
      ...action.labels,
    },
  }
}
